import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { PAGE_NAME } from '@/constants/constants';
import ReservationCalendar from "@/pages/ReservationCalendar.vue";
import EntryForm from "@/pages/EntryForm.vue";
import EntryForm2 from "@/pages/EntryForm2.vue";
import Product from "@/pages/Product.vue";
import PaymentCard from "@/pages/PaymentCard.vue";
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CNST_PAGE_NAME = PAGE_NAME;
        _this.corporateId = 0;
        _this.page = _this.CNST_PAGE_NAME.None;
        _this.productId = 0;
        _this.product = null;
        _this.entry = null;
        _this.scheduleInfo = null;
        return _this;
    }
    App.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var templatKey, templatPage, templatProduct;
            return __generator(this, function (_a) {
                this.$store.commit('setAppType', 'WORDPRESS');
                templatKey = document.getElementById('templat_key');
                templatPage = document.getElementById('templat_page');
                templatProduct = document.getElementById('templat_product');
                console.log("App created start templatKey=" + templatKey + " page=" + templatPage + " productId=" + templatProduct);
                // key: corporateID
                if (templatKey) {
                    this.corporateId = Number(templatKey.innerText);
                }
                else if ((isNaN(this.corporateId) || this.corporateId === 0) && this.$route.query.cid) {
                    // for Test
                    this.corporateId = Number(this.$route.query.cid.toString());
                }
                this.$store.commit('setCorporateID', this.corporateId);
                // page
                if (templatPage) {
                    this.page = templatPage.innerText;
                }
                else if (this.page === this.CNST_PAGE_NAME.None && this.$route.query.page) {
                    // for Test
                    this.page = this.$route.query.page.toString();
                }
                this.$store.commit('setPage', this.page);
                // product
                if (templatProduct) {
                    this.productId = Number(templatProduct.innerText);
                }
                else if ((isNaN(this.productId) || this.productId === 0) && this.$route.query.pid) {
                    // for Test
                    this.productId = Number(this.$route.query.pid.toString());
                }
                this.$store.commit('setProductId', this.productId);
                console.log("Top corporateIdc=" + this.corporateId + " page=" + this.page + " productId=" + this.productId);
                return [2 /*return*/];
            });
        });
    };
    App.prototype.goCalendar = function () {
        this.$refs.calendar.refresh();
        this.routePush(PAGE_NAME.Calendar);
    };
    App.prototype.goEntry = function (scheduleInfo) {
        this.scheduleInfo = scheduleInfo;
        this.routePush(PAGE_NAME.EntryForm);
    };
    App.prototype.goEntry2 = function () {
        // this.routePush(PAGE_NAME.EntryForm2)
        window.location.href = 'http://localhost:3000/public';
    };
    App.prototype.applied = function (entry) {
        var _this = this;
        // this.$refs.calendar.refresh()
        // this.routePush(PAGE_NAME.Calendar)
        this.entry = entry;
        this.routePush(PAGE_NAME.Payment);
        this.$nextTick(function () {
            _this.moveToTop();
        });
    };
    App.prototype.appliedByGuest = function (entry) {
        // TODO 会員サイトへリンク
        window.location.href = process.env.VUE_APP_CES_PATH + "/public/entry/" + entry.id + "/payment";
    };
    App.prototype.paid = function () {
        this.$refs.calendar.refresh();
        this.routePush(PAGE_NAME.Calendar);
    };
    App.prototype.moveToTop = function () {
        var duration = 200; // 移動速度（1秒で終了）
        var interval = 10; // 0.025秒ごとに移動
        var step = -window.scrollY / Math.ceil(duration / interval); // 1回に移動する距離
        var timer = setInterval(function () {
            window.scrollBy(0, step); // スクロール位置を移動
            if (window.scrollY <= 0) {
                clearInterval(timer);
            }
        }, interval);
    };
    App.prototype.routePush = function (page) {
        if (page) {
            this.page = page;
        }
    };
    App = __decorate([
        Component({
            components: { PaymentCard: PaymentCard, Product: Product, EntryForm: EntryForm, EntryForm2: EntryForm2, ReservationCalendar: ReservationCalendar }
        })
    ], App);
    return App;
}(Vue));
export default App;
